import pda from './pda'
import web from './web'
import wap from './wap'
import app from './app'

export default [...web, ...pda, ...wap, ...app]